import { getCountry } from '@iwIntlProvider/CountryProvider';
import { IconExclamationTriangleFilled } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import styles from './RevokedView.module.css';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';

const RevokedView = () => {
    return (
        <MainSectionWrapper className={styles.wrapper}>
            <div className={styles.card}>
                <div className={styles.iconContainer}>
                    <IconExclamationTriangleFilled
                        className={styles.titleIcon}
                    />
                </div>

                <div className={styles.title}>
                    <FormattedMessage
                        id="_.revoked_view.title"
                        defaultMessage="Oops, it looks like something went wrong"
                    />
                </div>

                {getCountry() === 'DE' && (
                    <div className={styles.bodyText}>
                        {/* eslint-disable formatjs/enforce-placeholders -- p and phoneNumber used in DE translation only */}
                        <FormattedMessage
                            data-test-id="declined-body-text"
                            id="_.revoked_view.description"
                            defaultMessage="_"
                            values={{
                                p: (chunks) => <p>{chunks}</p>,
                                phoneNumber: (
                                    <a
                                        href="tel:069 9432 3020"
                                        className={styles.phoneNumber}
                                    >
                                        <FormattedMessage
                                            tagName="strong"
                                            id="_.revoked_view.phoneNumber"
                                            defaultMessage="_"
                                        />
                                    </a>
                                )
                            }}
                        />
                        {/* eslint-enable formatjs/enforce-placeholders */}
                    </div>
                )}
            </div>
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default RevokedView;
